import { configAtom } from "@/config.ts";
import type { VmSizePackage } from "@/modules/compute/VmSize.types.ts";
import { useAtomValue } from "jotai/react";
import { atom } from "jotai/vanilla";

const defaultPackages: VmSizePackage[] = [
    { cpu: 1, ram: 0.5, ssd: 20, default: [], os: ["other"] },
    { cpu: 1, ram: 1, ssd: 30, default: ["other"], os: ["other"] },
    { cpu: 2, ram: 2, ssd: 40, default: [], os: ["other", "win"] },
    { cpu: 2, ram: 4, ssd: 60, default: ["win"], os: ["other", "win"] },
    { cpu: 4, ram: 8, ssd: 120, default: [], os: ["win"] },
    { cpu: 8, ram: 16, ssd: 240, default: [], os: ["win"] },
];

const packagesAtom = atom((get) => {
    const { predefinedPackages } = get(configAtom);
    const packages = !predefinedPackages.length ? defaultPackages : predefinedPackages;
    return packages.map((p): VmSizePackage => ({ ...p, ram: p.ram * 1024 }));
});

export function usePackages() {
    return useAtomValue(packagesAtom);
}
